var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1254_2068)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1254_2068)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1721 18.6215C14.3351 18.4584 14.5995 18.4584 14.7625 18.6215L17.1756 21.0346L18.9638 19.2465C19.1268 19.0834 19.3911 19.0834 19.5542 19.2465L22.3832 22.0755L22.3832 20.5834C22.3832 20.3528 22.5701 20.1659 22.8007 20.1659C23.0313 20.1659 23.2182 20.3528 23.2182 20.5834L23.2181 23.0834C23.2181 23.314 23.0312 23.5009 22.8006 23.5009L20.3007 23.5009C20.0701 23.5009 19.8832 23.3139 19.8832 23.0834C19.8832 22.8528 20.0701 22.6659 20.3007 22.6659L21.7927 22.6659L19.259 20.1321L17.4709 21.9203C17.3078 22.0833 17.0435 22.0833 16.8804 21.9203L14.1721 19.2119C14.009 19.0489 14.009 18.7845 14.1721 18.6215Z",
    fill: "#FF95B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7623 8.135L14.6503 7.98574C14.6876 8.02306 14.7996 8.06037 14.9115 8.06037C15.0235 8.06037 15.1354 8.02306 15.2474 7.91111H15.322L16.8893 5.6348C17.0759 5.44821 17.0759 5.26163 16.8893 5.07505C15.434 3.65702 13.5681 2.83606 11.2172 2.64947V0.447798C11.2172 0.149266 11.0679 0 10.7694 0H9.09014C8.79161 0 8.64234 0.149266 8.64234 0.447798V2.57484C5.05996 2.98532 2.70901 5.22431 2.70901 8.135C2.70901 9.77693 3.30608 10.9711 4.35094 11.8293C5.35849 12.7249 6.85115 13.2847 8.64234 13.6952V17.9493C7.07505 17.7627 5.65702 16.979 4.31362 15.6356L4.23899 15.561C4.20168 15.5237 4.12704 15.5237 4.01509 15.5237C3.82851 15.5237 3.71656 15.561 3.67924 15.7103L2.07463 18.0612C2.03732 18.0985 2 18.1732 2 18.2851C2 18.4344 2.03732 18.5463 2.14927 18.6583C3.86583 20.3748 6.03019 21.3077 8.67966 21.569V23.6214C8.67966 23.9199 8.82893 24.0692 9.12746 24.0692H10.8067C11.1052 24.0692 11.2545 23.9199 11.2545 23.6214V21.569C12.4234 21.4465 13.4363 21.1613 14.2821 20.7361L13.465 19.919C12.9114 19.3655 12.9114 18.468 13.465 17.9144C14.0185 17.3608 14.9161 17.3608 15.4696 17.9144L16.4359 18.8807C17.0294 17.9925 17.3371 16.9204 17.3371 15.7103C17.3371 14.5161 16.9266 13.5459 16.3295 12.7623C15.6952 12.0159 14.9115 11.3815 14.1652 11.0457C13.4562 10.7098 12.4859 10.4113 11.2918 10.1128V6.34381C12.5979 6.64234 13.7174 7.23941 14.7623 8.135ZM8.64234 9.36645C7.37358 8.88134 6.70188 8.3589 6.70188 7.76184C6.70188 6.71698 7.37358 6.11991 8.64234 6.00796V9.36645ZM11.1799 14.2176C12.6352 14.6654 13.3069 15.2251 13.3069 15.9715C13.3069 16.979 12.6352 17.5761 11.1799 17.8746V14.2176Z",
    fill: "#FF95B4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1254_2068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1254_2068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceDrop);
export default __webpack_public_path__ + "static/media/priceDrop.004991cbe56004d4e9b0668a002c668f.svg";
export { ForwardRef as ReactComponent };